export default "__VITE_ASSET__DdLWFd_3__"